import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=3ce81889"
import script from "./base-button.vue?vue&type=script&lang=js"
export * from "./base-button.vue?vue&type=script&lang=js"
import style0 from "./base-button.vue?vue&type=style&index=0&id=3ce81889&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports